export const checkExpiryDate = (expiryDate: any) => {
  if (!expiryDate) return false;
  const parts = expiryDate.split('/');
  const expiryYear = parseInt(parts[1], 10);
  const expiryMonth = parseInt(parts[0], 10);
  const currentYear = parseInt(new Date().getFullYear().toString().substr(-2));
  const currentMonth = new Date().getMonth() + 1;
  if (expiryYear === currentYear) {
    if (expiryMonth > currentMonth) {
      return true;
    }
    return false;
  } else if (expiryYear > currentYear) {
    return true;
  }
  return false;
};

export const checkPostalCode = (postalAdd: any) => {
  if (!postalAdd) return false;
  const regex = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/;
  return regex.test(postalAdd);
};

export const expiryDateFormatter = (event: any) => {
  const prevExpiry = event.target.value.split(' / ').join('/');
  if (!prevExpiry) return '';
  let expiry = prevExpiry;
  if (/^[2-9]$/.test(expiry)) {
    expiry = `0${expiry}`;
  }
  if (prevExpiry.length === 2 && +prevExpiry > 12) {
    const [head, ...tail] = prevExpiry.split('');
    expiry = `0${head}/${tail.join('')}`;
  }
  if (/^1[/-]$/.test(expiry)) {
    return `01 / `;
  }
  expiry = expiry.match(/(\d{1,2})/g).join('/');
  return expiry;
};

export const maskCardNumber = (cardNumber: string) => {
  let numbersToBeMasked = cardNumber.substring(0, cardNumber.length - 4);
  let lastdigits = `${cardNumber.slice(-4)}`;
  let maskedDigits = '';
  for (let i = numbersToBeMasked.length; i > 0; i--) {
    maskedDigits += 'X';
  }
  let finalMaskedDigit = maskedDigits + lastdigits;
  if (finalMaskedDigit.length > 0) {
    finalMaskedDigit = (
      finalMaskedDigit.match(new RegExp('.{1,4}', 'g')) || []
    ).join('-');
  }
  return finalMaskedDigit;
};

export const convertExpiryDate = (date: string) => {
  const splittedDate = date.match(/\d+/g);
  return splittedDate && `${splittedDate[1]}/${splittedDate[0].slice(-2)}`;
};

export const validatePaymentAmount = (e: any) => {
  const inNumber = e.target.value;
  if (!isNaN(inNumber)) {
    return inNumber;
  }
};
